import CustomSelect from "@Common/CustomSelect"
import Input from "@Common/input"
import { useTranslation } from "react-i18next"
import { useMemo } from "react"
import { useFormContext } from "react-hook-form"
import { IFormUserManagementCentre } from "../.."
import { LoadingWrapper } from "@components"
import { useOwnerManagment } from "@services"
import { Box, Typography } from "@mui/material"

export default function FormInputsAddOwner() {
	const {
		t,
		i18n: { language },
	} = useTranslation()
	
	/* ---------------------------------- API'S --------------------------------- */
	const { GetOwnersQuery } = useOwnerManagment()
	const { data: owners, isLoading } = GetOwnersQuery({
		pageNumber: '1',
		pageSize: '100',
		search: '',
	})

	/* ---------------------------------- Hooks --------------------------------- */
	const { watch } = useFormContext<IFormUserManagementCentre>()
	
	const listOfOwners = useMemo(() => {
		const dataList = owners?.data?.result
			?.filter((item: any) => item.hasAccount === false) // Only show owners without accounts
			?.map((item: any) => {
				return {
					label: `${item.firstName} ${item.lastName}`,
					value: item.ownerId?.toString() || item.id?.toString() || '',
				}
			})
			?.filter((item: any) => item.value !== '')
		return dataList ?? []
	}, [owners])

	return (
		<LoadingWrapper loading={isLoading}>
			<div>
				<CustomSelect
					data={listOfOwners}
					label={t("UserManagement.select_owner")}
					name='ownerId'
					registerOptions={{
						required: {
							value: true,
							message: t("COMMON.REQUIRED"),
						},
					}}
				/>
				<Input
					label={t("UserManagement.email")}
					placeholder={t("UserManagement.email")}
					name='email'
					type="email"
					registerOptions={{
						required: {
							value: true,
							message: t("COMMON.REQUIRED"),
						},
						pattern: {
							value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
							message: t("UserManagement.please_enter_valid_email") || "Please enter a valid email address",
						},
					}}
				/>
				<Box sx={{ mt: 2, mb: 2 }}>
					<Typography sx={{
						color: 'rgba(98, 87, 131, 1)',
						fontWeight: 400,
						fontSize: '14px',
						lineHeight: '20px'
					}}>
						{t("UserManagement.owner_will_receive_email_to_set_password")}
					</Typography>
				</Box>
			</div>
		</LoadingWrapper>
	)
}
